import {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {Card as FabricCard} from '~/common/canvas/Card/Card';
import {GrcCard} from '~/common/fabric/Card/components/AnimationPreview/components/GrcCard';
import {selectUsedAs} from '~/common/fabric/reducers/eviteEvent/selectors';
import {isGreetingCardByUsedAs} from '~/common/utils/event_utils';
import {PremiumCarousel} from './PremiumCarousel';
import './Premium.sass';

export const AnimationPreview = ({
  message,
  fabricArt,
  hideFlipButton,
  isWebview,
  initCardFlipped,
  recipientName,
}) => {
  const [replayOffsetWidth, setReplayOffsetWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const previewRef = useRef();
  const cardRef = useRef();
  const usedAs = useSelector(selectUsedAs);

  useEffect(() => {
    setReplayOffsetWidth(cardRef?.current?.offsetWidth);
    setHeight(cardRef.current?.style?.height || cardRef?.current?.offsetHeight);
  }, []);

  const content = useMemo(
    () =>
      hideFlipButton ? (
        <div ref={cardRef}>
          <FabricCard fabricArt={fabricArt} imageRef={cardRef} />
        </div>
      ) : (
        <GrcCard yourInvitationRef={cardRef} message={message} fabricArt={fabricArt} />
      ),
    [hideFlipButton, message, fabricArt]
  );

  const animationStartCallback = useCallback(() => {
    if (!hideFlipButton) {
      cardRef.current?.firstChild?.classList.add('hidden-btn');
      cardRef.current?.setCardFlipped?.(false);
    }
  }, [hideFlipButton]);

  const animationEndCallback = useCallback(
    (isFirstRender) => {
      if (!hideFlipButton) {
        cardRef.current?.setCardFlipped?.(initCardFlipped && isFirstRender);
        cardRef.current?.firstChild?.classList.remove('hidden-btn');
      }
    },
    [initCardFlipped, hideFlipButton]
  );

  return (
    <div ref={previewRef} id="animation-preview" className="fabric-grc-animation-preview">
      <PremiumCarousel
        isWebview={!!isWebview}
        height={height}
        fabricArt={fabricArt}
        replayOffsetWidth={replayOffsetWidth}
        recipientName={recipientName}
        animationEndCallback={animationEndCallback}
        animationStartCallback={animationStartCallback}
      >
        <div
          className={isGreetingCardByUsedAs(usedAs) ? 'fabric-greeting-animation--scale-down' : ''}
        >
          {content}
        </div>
      </PremiumCarousel>
    </div>
  );
};
